export const buildNumber = '20241004.3';
export const version = '3.6.0';
export const latestCommit = 'af5255e1f49697e61e06238df239f30325ca2ce1';
